import { agenciesConstants } from '../constants/agencies';

const initialState = {
  items: [],
  webmasterAgencies: [],
  paymentPurses: {},
  payments: {
    items: [],
    count: 0,
  },
  redirectToAgenciesData: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case agenciesConstants.SET_AGENCIES_SUCCESS:
      return {
        ...state,
        items: action.agencies,
      };

    case agenciesConstants.SET_WM_AGENCIES_SUCCESS:
      return {
        ...state,
        webmasterAgencies: action.agencies,
        paymentPurses: action.purses,
      };

    case agenciesConstants.SET_AGENCY_STATUS:
      return {
        ...state,
        items: state.items.map(
          agency =>
            agency.id === action.id && agency.type === action.agencyType
              ? {
                  ...agency,
                  status: action.status,
                }
              : agency,
        ),
      };
    case agenciesConstants.SET_PAYMENTS_LOG_SUCCESS:
      return {
        ...state,
        payments: {
          items: action.payments,
          count: action.count,
        },
      };
    case agenciesConstants.SET_AGENCY_PROMOCODE:
      return {
        ...state,
        items: state.items.map(agency =>
          agency.id === action.id ? { ...agency, promo_code: action.code } : agency,
        ),
      };
    case agenciesConstants.SET_REDIRECT_TO_AGENCIES_DATA:
      return {
        ...state,
        redirectToAgenciesData: {
          agencyId: action.agencyId
        },
      };
    case agenciesConstants.CLEAR_REDIRECT_TO_AGENCIES_DATA:
      return {
        ...state,
        redirectToAgenciesData: {},
      }
    default:
      return state;
  }
};
